import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage, FormikHelpers } from "formik";
import * as Yup from "yup";
import { Enquiry } from "services/types";
import { postEnquiry } from "services/auth.service";
import { useVendor } from "contexts/vendor.context";

const initialValues: Enquiry = {
  name: "",
  email: "",
  subject: "",
  message: "",
};

const validationSchema: Yup.ObjectSchema<Enquiry> = Yup.object({
  name: Yup.string().required("Name is required"),
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  subject: Yup.string().required("Subject is required"),
  message: Yup.string().required("Message is required"),
});


function ContactPage() {
  const { vendor } = useVendor();
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [successMessage, setSuccessMessage] = useState<string>("");

  const handleSubmit = async (
    values: Enquiry,
    { setSubmitting, resetForm }: FormikHelpers<Enquiry>
  ) => {
    try {
      const response = await postEnquiry(values);
      console.log(response);

      setErrorMessage("");
      setSuccessMessage(response.message);
      resetForm();
    } catch (error: any) {
      setSuccessMessage("");
      setErrorMessage(error.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <React.Fragment>
      <section id="contact" className="contact section">
        <div className="container section-title" data-aos="fade-up">
          <h2>Contact</h2>
          <div>
            <span>Check Our</span> <span className="description-title">Contact</span>
          </div>
        </div>

        <div className="container" data-aos="fade" data-aos-delay="100">
          <div className="row gy-4">
            <div className="col-lg-4">
              <div className="info-item d-flex" data-aos="fade-up" data-aos-delay="200">
                <i className="bi bi-geo-alt flex-shrink-0"></i>
                <div>
                  <h3>Address</h3>
                  <p>{vendor?.company_address}</p>
                  <p>State- {vendor?.state}, {vendor?.country}-{vendor?.pincode}</p>
                </div>
              </div>
              <div className="info-item d-flex" data-aos="fade-up" data-aos-delay="300">
                <i className="bi bi-phone flex-shrink-0"></i>
                <div>
                  <h3>Phone</h3>
                  <p>{vendor?.company_phone}</p>
                </div>
              </div>
              <div className="info-item d-flex" data-aos="fade-up" data-aos-delay="300">
                <i className="bi bi-telephone flex-shrink-0"></i>
                <div>
                  <h3>Landline</h3>
                  <p>{vendor?.company_landline}</p>
                </div>
              </div>
              <div className="info-item d-flex" data-aos="fade-up" data-aos-delay="400">
                <i className="bi bi-envelope flex-shrink-0"></i>
                <div>
                  <h3>Email Us</h3>
                  <p>{vendor?.company_email}</p>
                </div>
              </div>
            </div>

            <div className="col-lg-8">
              <Formik<Enquiry>
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({ isSubmitting }) => (
                  <Form
                    className="php-email-form"
                    data-aos="fade-up"
                    data-aos-delay="200"
                  >
                    <div className="row gy-4">
                      <div className="col-md-6">
                        <Field
                          type="text"
                          name="name"
                          className="form-control"
                          placeholder="Your Name"
                        />
                        <ErrorMessage
                          name="name"
                          component="div"
                          className="invalid-feedback d-block"
                        />
                      </div>

                      <div className="col-md-6">
                        <Field
                          type="email"
                          name="email"
                          className="form-control"
                          placeholder="Your Email"
                        />
                        <ErrorMessage
                          name="email"
                          component="div"
                          className="invalid-feedback d-block"
                        />
                      </div>

                      <div className="col-md-12">
                        <Field
                          type="text"
                          name="subject"
                          className="form-control"
                          placeholder="Subject"
                        />
                        <ErrorMessage
                          name="subject"
                          component="div"
                          className="invalid-feedback d-block"
                        />
                      </div>

                      <div className="col-md-12">
                        <Field
                          as="textarea"
                          name="message"
                          className="form-control"
                          rows={6}
                          placeholder="Message"
                        />
                        <ErrorMessage
                          name="message"
                          component="div"
                          className="invalid-feedback d-block"
                        />
                      </div>

                      <div className="col-md-12 text-center">
                        {isSubmitting && <div className="loading">Loading</div>}
                        {errorMessage && <div className="error-message">{errorMessage}</div>}
                        {successMessage && <div className="sent-message">Your message has been sent. Thank you!</div>}
                        <button type="submit">Send Message</button>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
}

export default ContactPage;
